<template>
  <el-dialog
    class="modal-select-role"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
     custom-class="greater"
  >
    <div class="content" v-loading="isLoading">
      <div class="filter-box">
        <el-input v-model="roleName" placeholder="角色名称" style="width:291px;"></el-input>
        <el-button @click.stop="$_search" class="select__btn">搜索</el-button>
      </div>
      <div class="role-list clearfix">
        <!-- S 左侧 角色选择 -->
        <div class="role-list__left">
          <!-- 预设角色 -->
          <div class="role-list__default">
            <div class="container-header">
              当前可授权的角色如下
            </div>
            <el-scrollbar style="height:455px;">
            <ul class="roles-default">
              <li v-for="role in roleList" :key="role.rid">
                <el-radio
                  v-model="roleId"
                  :label="role.rid"
                  @change="$_changeRole(role)"
                >{{role.roleName}}</el-radio>
              </li>
            </ul>
            </el-scrollbar>
          </div>
        </div>
        <!-- E 左侧 角色选择 -->
        <!-- S 右侧 功能权限预览 -->
        <div class="role-list__right">
          <div class="container-header">
            选中角色的功能权限预览
          </div>
          <div class="selected-box">
          <el-scrollbar class="selected-left">
          <el-tree
            class="roles-tree-box selected-roles"
            :data="showFunctionList"
            :props="defaultProps"
             empty-text="←请在左边栏目中选择权限"
            default-expand-all
            node-key="fid"
          ></el-tree>
          </el-scrollbar>
           <div class="selected-menu">
            <h3 style="color:#3a3a3a;font-size:14px">功能权限</h3>
            <div class="selected-menu__txt">{{showFunctionList.length > 0 ? '已开通所有功能权限':'暂无功能权限'}}</div>
          </div>
          </div>
        </div>
        <!-- E 右侧 功能权限预览 -->
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";

export default {
  name: "select-role",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    platformKey: { type: String, default: "" },
    bindRoleId: { type: Number, default: 0 },
    roles: { type: Array, default: [] } // 预设角色
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      role: {},
      roleId: this.bindRoleId,
      roleName: "",
      roleList: [], // 过滤后的角色, 用于页面选择
      functionList: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  computed: {
    // 根据已选数据右侧进行预览
    showFunctionList() {
      return Utils.functionListToTree(this.functionList);
    }
  },
  methods: {
    $_search() {
      let roleName = this.roleName;
      this.roleList = this.roles.filter(
        item => item.roleName.match(roleName) !== null
      );
    },
    // 切换角色
    $_changeRole(role) {
      this.role = { ...role };
      this.functionList = role.functionList.concat([]);
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_submit() {
      if (this.roleId === 0) {
        $MessageBox.alert({ content: "请选择相应角色" });
        return false;
      }
      this.$emit("submit", this.role);
    }
  },
  created() {
    this.isLoading = true;
    this.$_search();
    this.$nextTick(() => {
      if (this.bindRoleId > 0) {
        let item = this.roleList.find(item => item.rid === this.bindRoleId);
        if (typeof item !== "undefined") {
          this.functionList = [...item.functionList];
        }
      }
      this.isLoading = false;
    });
  },
  mounted() {
    this.visible = true;
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-scrollbar {
  // overflow: hidden;
  position: relative;
  &:active,
  &:focus,
  &:hover {
    .el-scrollbar__bar {
      opacity: 1;
      transition: opacity 340ms ease-out;
      border-radius: 0;
    }
  }
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  max-height: 510px;
}
/deep/ .el-tree-node__label {
  font-weight: 400;
}
.content {
  height: 100%;
  padding: 24px 30px 0;
}
.role-list {
  &__left,
  &__right {
    width: 450px;
    height: 510px;
    // overflow-y: auto;
    background-color: #f9f9f9;
    border:1px solid #eee;
  }
  &__left {
    float: left;
  }
  &__right {
    float: right;
  }
}
.select__btn {
  margin-bottom: 10px;
  margin-left: 10px;
}
.role-list__default {
  h3 {
    padding: 15px;
  }
}

.h3 {
  padding: 20px;
}

.roles-default,
.selected-roles {
  height: 290px;
  // overflow-y: auto;
}
.selected-roles {
  padding: 10px 10px;
  width: 200px;
  height:519px;
  background-color: #363c54;
  // overflow-y: auto;
  color:#fff;
}
.roles-default {
  padding-left: 15px;
  padding-top: 15px;
  li {
    padding-bottom: 10px;
  }
}
/deep/ .el-tree-node__content {
    color: #fff;
    &:hover {
      color: #49b2ef;
      background-color: transparent;
    }
  }
/deep/ .el-tree-node:focus > .el-tree-node__content{
  background-color: transparent;
}
.container-header{
  height: 40px;
  border-bottom: 1px solid #eee;
  background-color: #f5f6f7;
  line-height: 40px;
  padding-left:15px;
}
.selected-box {
    display: flex;
  }
  .selected-menu {
    flex: 1;
    color: #535353;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    h3 {
      color: #3a3a3a;
      line-height: 36px;
      padding-left: 12px;
    }
    &__txt {
      display: flex;
      font-size: 12px;
      flex: 1;
      justify-content: center;
      align-items: center;
    }
  }
  .selected-left{
    background-color: #363c54;
    height: 468px;
  }
</style>
